import type {
  ParameterSetsOutputLogicalBffV2Api,
  ParameterSetsOutputLogicalV2Api,
} from '@ingenico/api-sdk-device-management-private-v2';

export function mapOutputFile(response: ParameterSetsOutputLogicalV2Api): ParameterSetsOutputLogicalV2Api {
  return response;
}

export function mapOutputFilesV2(response: ParameterSetsOutputLogicalBffV2Api): ParameterSetsOutputLogicalBffV2Api {
  return response;
}
